export default {
  namespaced: true, // 开启模块化命名空间
  state: {
    // 初始化时从 localStorage 读取用户信息，如果解析失败则返回 null
    userInfo: (() => {
      try {
        return JSON.parse(localStorage.getItem('user')) || null;
      } catch {
        return null;
      }
    })(),
  },
  mutations: {
    // 更新用户信息，并同步到 localStorage
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      if (userInfo) {
        localStorage.setItem('user', JSON.stringify(userInfo));
      } else {
        localStorage.removeItem('user');
      }
    },
    // 清除用户信息，并移除 localStorage 中的数据
    clearUserInfo(state) {
      state.userInfo = null;
      localStorage.removeItem('user');
      localStorage.removeItem('token')
    },
  },
  actions: {
    // 模拟用户登录（接收用户信息对象）
    login({ commit }, userCredentials) {
      commit('setUserInfo', userCredentials);
    },
    // 用户登出
    logout({ commit }) {
      commit('clearUserInfo');
    },
  },
  getters: {
    // 获取用户信息
    getUserInfo: (state) => state.userInfo,

    // 获取用户 ID
    userId: (state) => state.userInfo?.user_id || '',

    // 管理员权限（用户 ID 为 16 或 17）
    adminPermission: (state) => [16, 17].includes(state.userInfo?.user_id),

    // 前台权限（用户 ID 为 18）
    frontdeskPermission: (state) => state.userInfo?.user_id == 18,

    // 经理权限（用户 ID 为 2）
    managerPermission: (state) => state.userInfo?.user_id == 2,

    // 员工权限（非管理员、非经理、非前台，且存在 user_id）
    employeePermission: (state) => {
      const userId = state.userInfo?.user_id;
      if (!userId) return false;
      return ![2, 16, 17, 18].includes(userId);
    },
  },
};
